import * as actions from '../actions/currentLayoutActionTypes';

const initialState = {
  sidebarShow: "responsive"
}

function currentLayout(state =initialState, action) {
  switch (action.type) {    
    case actions.CURRENT_LAYOUT_SET:
      return {
        ...state, 
        sidebarShow: action.sidebarShow
      }      
    default:
      return state
  } 
}

export default currentLayout